<template>
    <AppActionBase bg="transparent" icon-url="/assets/icons/print.svg" alt="Print"
        :custom-class="`btn-print-style ${customClass}`" v-bind="$attrs" @click="$emit('click', $event)" />
</template>

<script>
import AppActionBase from './AppActionBase.vue';

export default {
    name: 'AppActionPrint',
    components: {
        AppActionBase
    },
    props: {
        customClass: {
            type: String,
            default: ''
        }
    },
    emits: ['click']
}
</script>
